import { Link, useRouterState } from '@tanstack/react-router'
import { FileText, Search, UtensilsCrossed } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function BottomTabs() {
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const searchBackground = useRouterState({ select: (state) => state.location.state.noteBackgroundPage === 'search' })
  const searchActive = pathname === '/search' || pathname.startsWith('/meal/') || (pathname.startsWith('/notes/') && searchBackground)
  const mealsActive = pathname === '/meals'
  const notesActive = !mealsActive && !searchActive

  return <nav className="bottom-tabs" aria-label="Main sections">
    <Button asChild variant="ghost" className="bottom-tab" data-active={notesActive}>
      <Link to="/" aria-label="Notes" aria-current={notesActive ? 'page' : undefined}><FileText className="size-5" /><span>Notes</span></Link>
    </Button>
    <Button asChild variant="ghost" className="bottom-tab" data-active={mealsActive}>
      <Link to="/meals" aria-label="Meals" aria-current={mealsActive ? 'page' : undefined}><UtensilsCrossed className="size-5" /><span>Meals</span></Link>
    </Button>
    <Button asChild variant="ghost" className="bottom-tab" data-active={searchActive}>
      <Link to="/search" aria-label="Search" aria-current={searchActive ? 'page' : undefined} onClick={(event) => {
        if (pathname === '/search' && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
          event.preventDefault()
          document.getElementById('global-search')?.focus()
        }
      }}><Search className="size-5" /><span>Search</span></Link>
    </Button>
  </nav>
}
